
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {

	const blockProps = useBlockProps({
		className: 'c4l-attention'
	});

	const {
		attributes,
		setAttributes
	} = props;

	const {
		content
	} = attributes;

	return (
		<div {...blockProps}>
			<RichText
				tagName='div'
				className='c4l-attention-content'
				multiline='p'
				value={content}
				onChange={(newVal) => setAttributes({ content: newVal })}
				placeholder={__('Type the attention content here', 'attention')}
			/>
		</div>
	);
}
